export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '韩漫天堂上的漫画都是免费的吗？',
    answer: '是的，韩漫天堂上的所有漫画资源均免费提供在线阅读。您无需注册账号、无需支付任何费用，即可畅享海量韩国漫画。我们通过广告收入维持平台运营，致力于为广大漫迷提供优质的免费阅读体验。',
  },
  {
    question: '需要注册账号才能阅读漫画吗？',
    answer: '不需要！韩漫天堂的最大特色就是无需注册即可直接阅读。打开网站，选择您喜欢的漫画，点击即可开始阅读。当然，我们也提供可选的账号注册功能，注册后可以收藏漫画、记录阅读进度，获得更个性化的体验。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '韩漫天堂完美适配电脑、平板和手机等各类设备。无论您使用Windows、Mac、iOS还是Android系统，都能获得流畅舒适的阅读体验。我们的网站采用响应式设计，会自动根据您的屏幕尺寸调整排版布局。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '我们的编辑团队每日更新漫画内容，确保您能第一时间看到最新的章节。热门连载漫画通常保持每周更新2-3话的节奏。您可以在首页的"最新更新"板块查看最近上架的漫画。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：在首页的分类导航中按题材筛选（恋爱、奇幻、动作等）；使用顶部搜索栏直接搜索漫画名称或作者；浏览"热门推荐"和"最新更新"板块发现热门作品。',
  },
  {
    question: '网站上的漫画有版权吗？',
    answer: '韩漫天堂高度重视知识产权保护。平台上的漫画内容均已获得正版授权或与版权方达成合作。我们严格遵守相关法律法规，致力于为创作者和读者搭建一个健康、合法的漫画阅读平台。如果您是版权方且有相关疑问，请通过"关于我们"页面中的联系方式与我们取得联系。',
  },
  {
    question: '漫画加载速度慢怎么办？',
    answer: '如果遇到漫画加载缓慢的情况，建议您：检查网络连接是否稳定；尝试刷新页面；清理浏览器缓存；切换至其他网络环境。我们持续优化服务器性能，确保为全国各地的用户提供流畅的阅读体验。',
  },
  {
    question: '可以下载漫画到本地阅读吗？',
    answer: '为了保护漫画作者的版权，韩漫天堂目前不支持漫画下载功能。但我们支持离线缓存功能（需注册账号），您可以在有网络时缓存章节，之后在无网络环境下阅读已缓存的内容。',
  },
];